import store from '../store';

store.watch((state) => state["sale"]["customers"], async (value) => {
    console.log("watch customer changed: ", value);
    const activeCustomerId = store.state["activeCustomer"]["customer"]["id"];
    if(activeCustomerId){
        const customer = value.find(c => c.id === activeCustomerId);
        console.log("watch customer changed: ", activeCustomerId,customer);
        store.commit("activeCustomer/setCustomer", customer);
        await store.dispatch("checkout/updateShippingAddress", customer.address);
        await store.dispatch("checkout/updateDraftOrder");
    }
});